"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionsDialogProviders = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
var _constants = require("../../constants");
var _defaultTranslations = require("../../constants/defaultTranslations");
var _jsxRuntime = require("react/jsx-runtime");
const TermsAndConditionsDialogProviders = ({
  children
}) => {
  const localLogger = (0, _logger.useLogger)('TermsAndConditionsDialogProviders');
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
    areaName: "TermsAndConditionsDialog",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
        defaultTranslationsWithNamespaces: {
          [_defaultTranslations.translationsNamespace]: _defaultTranslations.defaultTranslations
        },
        clientFetchConfiguration: {
          baseUrl: staticApiUrl,
          tenant,
          onError: error => localLogger.error(new Error('Failed to fetching translations', {
            cause: error
          }))
        },
        language: language,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
          namespace: _defaultTranslations.translationsNamespace,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_staticApiClientReact.ApiClientProvider, {
            baseUrl: staticApiUrl,
            language: language,
            tenant: tenant,
            timeout: _constants.TIMEOUT_IN_MS,
            children: children
          })
        })
      })
    })
  });
};
exports.TermsAndConditionsDialogProviders = TermsAndConditionsDialogProviders;
